import { render, staticRenderFns } from "./Pictures.vue?vue&type=template&id=571afb9b&scoped=true&"
import script from "./Pictures.vue?vue&type=script&lang=js&"
export * from "./Pictures.vue?vue&type=script&lang=js&"
import style0 from "./Pictures.vue?vue&type=style&index=0&id=571afb9b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571afb9b",
  null
  
)

export default component.exports